import type { FC, ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useUrlWithSearchParams } from "../../helpers/routeHelpers";
import { useEnableFacilitiesManagement } from "../../helpers/context-hooks/useEnableFacilitiesManagement";

export const FacilitiesManagementRoute: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const { enableFacilitiesManagement } = useEnableFacilitiesManagement();

  const redirect = useUrlWithSearchParams("/");

  if (enableFacilitiesManagement) {
    return <>{children}</>;
  }
  // Facilities management not enabled, go to landing page.
  return <Navigate to={redirect} replace />;
};
